var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifier},[_c('transition',{attrs:{"name":"slide"}},[_c('nav-browse',{key:(_vm.rotationIndex + "-" + _vm.isLayoutMobile)})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-315b2671","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/app-secondary-nav/app-secondary-nav.vue
// module id = FMYX
// module chunks = 65